export default __webpack_public_path__ + "bannerWithContentOverlay.ad2d2ade8639c5fc50c679af3464093d.png";